export default __webpack_public_path__ + "static/carton-036b69dba271cea82413948dbb4ba53c.png";